module.exports = __webpack_public_path__ + "img/2 手机.200979b1.png";